import { getDataBase } from '@/db';
import FechaHora from '@/utils/FechaHora';


export default class GeneracionLecturaMovilDAL   {

    async Existe (GeneracionFactura, Cliente, DataBaseAlias) {
        
        try {
            const db = await getDataBase();
            const tx = db.transaction('GENERACIONLECTURAMOVIL', 'readonly');
            const store = tx.objectStore('GENERACIONLECTURAMOVIL');
            const laResult = await store.getAll(Cliente);
           
            const laReturn = [];
            laResult.forEach(loResult => {
                if (loResult.GeneracionFactura ==  Number(GeneracionFactura)) {
                    laReturn.push(loResult);
                }
            });
            await tx.done;
            return laReturn;
        } catch (error) {
            console.error('Error en Existe:', error);
            return [];
        }
    }

    async Update(TipoReglaAplicar, GeneracionFactura, Cliente, Categoria, Medidor, 
        TipoConsumo, AplicarPromedio, ConsumoFacturado, AjusteConsumo, AjusteMonto, DesviacionSignificativa, 
        InspeccionRequerido, Facturado, ValidoLectura, MedidorAnormalidad2, DataBaseAlias) {
    
        try {
            // Conectar a la base de datos
            const db = await getDataBase();
            const tx = db.transaction('GENERACIONLECTURAMOVIL', 'readwrite');
            const store = tx.objectStore('GENERACIONLECTURAMOVIL');
            // const index = store.index('GeneracionFactura');
            const laReturn = await store.getAll(Cliente);
            const loFechaHora = new FechaHora();

            if (laReturn == null || laReturn.length == 0) {
                console.error("Registro no encontrado");
                return null;
            }
    
            // Actualizar los valores del registro
            laReturn[0].Fecha = loFechaHora.getFecha(); // Fecha actual (Y-m-d)
            laReturn[0].Hora = loFechaHora.getHora(); // Hora actual (H:i:s)
            laReturn[0].Categoria = Categoria;
            laReturn[0].Medidor = Medidor;
            laReturn[0].TipoConsumo = TipoConsumo;
            laReturn[0].MedidorAnormalidad2 = MedidorAnormalidad2;
            laReturn[0].AplicacionConMedidor = AplicarPromedio ? 1 : 0;
            laReturn[0].ConsumoFactura = ConsumoFacturado;
            laReturn[0].AjusteConsumo = AjusteConsumo;
            laReturn[0].AjusteMonto = AjusteMonto;
            laReturn[0].DesviacionSignificativa = DesviacionSignificativa ? 1 : 0;
            laReturn[0].InspeccionRequerido = InspeccionRequerido ? 1 : 0;
            laReturn[0].Facturado = Facturado ? 1 : 0;
            laReturn[0].ValidoLectura = ValidoLectura ? 1 : 0;
    
            // Guardar los cambios en IndexedDB
            await store.put(laReturn[0]);
    
            // Completar la transacción
            await tx.done;
    
            return laReturn[0];
    
        } catch (error) {
            console.error("Error al actualizar GeneracionLecturaMovil", error);
            return null;
        }
    }
    

    async Insert(TipoReglaAplicar, GeneracionFactura, Cliente, Categoria, Medidor, 
        TipoConsumo, AplicarPromedio, ConsumoFacturado, AjusteConsumo, AjusteMonto, DesviacionSignificativa, 
        InspeccionRequerido, Facturado, ValidoLectura, MedidorAnormalidad2, DataBaseAlias) {
          
        try {
            // Conectar a la base de datos
            const db = await getDataBase(); // Conexión a la base de datos (IndexedDB)
    
            // Iniciar transacción con permisos de lectura/escritura
            const tx = db.transaction('GENERACIONLECTURAMOVIL', 'readwrite');
            const store = tx.objectStore('GENERACIONLECTURAMOVIL');
            const loFechaHora = new FechaHora();
    
            // Crear un nuevo registro con los valores pasados
            const loGeneracionLecturaMovil = {
                GeneracionFactura: Number(GeneracionFactura),
                Cliente: Cliente,
                Fecha: loFechaHora.getFecha(), // Fecha actual (Y-m-d)
                Hora: loFechaHora.getHora(),  // Hora actual (H:i:s)
                Categoria: Categoria,
                Medidor: Medidor,
                TipoConsumo: TipoConsumo,
                MedidorAnormalidad2: MedidorAnormalidad2,
                AplicacionConMedidor: AplicarPromedio ? 1 : 0,
                ConsumoFactura: ConsumoFacturado,
                AjusteConsumo: AjusteConsumo,
                AjusteMonto: AjusteMonto,
                DesviacionSignificativa: DesviacionSignificativa ? 1 : 0,
                InspeccionRequerido: InspeccionRequerido ? 1 : 0,
                Facturado: Facturado ? 1 : 0,
                ValidoLectura: ValidoLectura ? 1 : 0
            };
    
            // Insertar el nuevo registro en IndexedDB
            await store.add(loGeneracionLecturaMovil);
    
            // Completar la transacción
            await tx.done;
    
            return loGeneracionLecturaMovil;
    
        } catch (error) {
            console.error("Error al insertar en GeneracionLecturaMovil", error);
            return null;
        }
    }


    // public static function GetRecDt($tcGeneracionLectura, $tcCliente, $DataBaseAlias){
    //     $loGeneracionLecturaMovil = GeneracionLecturaMovil::on($DataBaseAlias)
    //                 ->where('GeneracionFactura', '=', $tcGeneracionLectura)
    //                 ->where('Cliente', '=', $tcCliente)->get();

    //     return $loGeneracionLecturaMovil;
    // }
    
    async GetRecDt(tcGeneracionLectura, tcCliente, DataBaseAlias){
        try {
       
            const db = await getDataBase(); // Conectar a IndexedDB
            const tx = db.transaction('GENERACIONLECTURAMOVIL', 'readonly');
            const store = tx.objectStore('GENERACIONLECTURAMOVIL');
            const laClientes = await store.getAll(tcCliente);
            const laResult = [];
            laClientes.forEach((loCliente)=>{
                if (loCliente.GeneracionFactura == tcGeneracionLectura) {
                    laResult.push(loCliente); 
                }
            });

            await tx.done;
            return laResult;

        } catch (error) {
            console.error(error);
            return [];
        }
    }
    
 
}